module.exports = __webpack_public_path__ + "img/importance.c1fc773e.png";